import { useEffect, useState } from 'react';
import { getReviewScore } from '@services/reviewservice';
import { useAppDispatch, useAppSelector } from './statehooks';
import { updateVehicleScore } from '@store/reducers/vehicleinformation';
import { ReviewScore } from 'interface';

export const useReviewScore = (capId: string | undefined) => {
  const dispatch = useAppDispatch();
  const vehicleInformation = useAppSelector(
    (state) => state.vehicleInformation
  );
  const [score, setReviewScore] = useState<string | undefined>(
    vehicleInformation.score
  );
  const [ready, setReady] = useState<boolean>(false);

  useEffect(() => {
    if (!score) {
      getReviewScore(capId)
        .then((res: ReviewScore) => {
          setReviewScore(res.score);
          dispatch(updateVehicleScore(res.score));
          setReady(true);
        })
        .catch(() => {
          setReady(true);
          setReviewScore(undefined);
        });
    } else {
      setReady(true);
    }
  }, []);

  return { ready, score };
};
